import React from 'react'

const EditPlayList = () => {
  return (
    <div>EditPlayList</div>
  )
}

export default EditPlayList